import "../style/Home.css";
import Doctorwithkid from "./images/Doctorwithkid.png";
import Pflegefachkraft from "./images/Pflegefachkraft.png";
import ImageCarousel from "./ImageCarousel";
import { FaClipboardCheck, FaHeartbeat, FaMapMarkerAlt } from "react-icons/fa";

function Home(props) {
    const features = [
        {
            icon: <FaClipboardCheck size={56} color="#111D4B" />,
            title: "Strukturierte Arbeitsweise",
            description:
                "Unser Team arbeitet effizient und organisiert, um optimale Ergebnisse zu erzielen.",
        },
        {
            icon: <FaHeartbeat size={56} color="#111D4B" />,
            title: "Am Puls der Zeit",
            description:
                "Wir bleiben über aktuelle Entwicklungen im Gesundheitswesen informiert, um bestmögliche Unterstützung zu bieten.",
        },
        {
            icon: <FaMapMarkerAlt size={56} color="#111D4B" />,
            title: "Deutschlandweit",
            description:
                "Unsere Dienstleistungen stehen Kliniken und Krankenhäusern in ganz Deutschland zur Verfügung.",
        },
    ];

    return (
        <>
            {/* Image with text overlay */}
            <div className="medway-hero home-hero">
                <img 
                    src={Doctorwithkid} 
                    alt="Doctor with child" 
                    className="medway-hero__image"
                />
                {/* Transparent text overlay */}
                <div
                    className="medway-hero__content home-hero__content"
                >
                    <h1
                        className="medway-hero__title"
                    >
                        Personalvermittlung mit
                        <br />
                        Leidenschaft
                    </h1>
                    <p
                        className="medway-hero__subtitle"
                    >
                        Engagierte medizinische Fachkräfte aus Tunesien für Krankenhäuser, Kliniken und Pflegeeinrichtungen
                    </p>
                    <a
                        href="/Dienstleistung"
                        style={{
                            display: "inline-block",
                            padding: "12px 26px",
                            borderRadius: "30px",
                            border: "1.5px solid #ffffff",
                            color: "#ffffff",
                            textDecoration: "none",
                            fontWeight: 600,
                            fontSize: "1rem",
                            background: "rgba(255,255,255,0.15)",
                            backdropFilter: "blur(2px)",
                        }}
                    >
                        Mehr zu unseren Leistungen
                    </a>
                </div>
            </div>

            {/* Highlight card */}
            <div style={{ backgroundColor: "#f5f8fb", padding: "60px 0" }}>
                <div
                    className="medway-section medway-card medway-section--center"
                >
                    <div style={{ color: "#111D4B", letterSpacing: "2px", fontWeight: "700" }}>
                        WILLKOMMEN BEI MEDWAY
                    </div>
                    <h2 style={{ marginTop: "12px", marginBottom: "12px", color: "#111D4B", fontSize: "32px" }}>
                        Ihre Unterstützung beim Personalbedarf
                    </h2>
                    <div
                        style={{
                            width: "70ch",
                            maxWidth: "100%",
                            height: "3px",
                            backgroundColor: "#b11955",
                            margin: "0 auto 28px",
                            borderRadius: "999px",
                        }}
                    />
                    <p style={{ color: "#4a4a4a", fontSize: "18px", lineHeight: "1.6", maxWidth: "860px", margin: "0 auto 46px" }}>
                        Willkommen bei MEDWAY, Ihrem professionellen Partner für die Personalvermittlung hochqualifizierter medizinischer Fachkräfte aus Tunesien.
                        Unser engagiertes Team aus erfahrenen, kompetenten Beratern und ehemaligen Anästhesie- und Intensivpflegern steht Ihnen zur Verfügung,
                        um maßgeschneiderte Lösungen für Ihre Bedürfnisse zu finden. Vereinbaren Sie noch heute einen Termin und profitieren Sie von unserem gebündelten
                        Fachwissen und unserer umfassenden Erfahrung.
                    </p>

                    <div className="home-feature-grid">
                        {features.map((feature) => (
                            <div key={feature.title} style={{ padding: "10px 16px" }}>
                                <div style={{ marginBottom: "18px" }}>{feature.icon}</div>
                                <h3 style={{ color: "#b11955", fontSize: "22px", marginBottom: "12px" }}>
                                    {feature.title}
                                </h3>
                                <p style={{ color: "#4a4a4a", fontSize: "16px", lineHeight: "1.5" }}>
                                    {feature.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>


            {/* Pflegefachkraft hero */}
            <div
                className="home-banner"
                style={{
                    backgroundImage: `linear-gradient(90deg, rgba(12, 22, 45, 0.75) 0%, rgba(12, 22, 45, 0.35) 55%, rgba(12, 22, 45, 0.1) 100%), url(${Pflegefachkraft})`,
                }}
            >
                <div className="home-banner__inner">
                    <div className="home-banner__content">
                        <h2
                            style={{
                                fontSize: "clamp(2.2rem, 4vw, 3.4rem)",
                                fontWeight: 300,
                                lineHeight: 1.08,
                                marginBottom: "16px",
                            }}
                        >
                            Erfüllen Sie sich Ihren
                            <br />
                            Personaltraum
                        </h2>
                        <p
                            style={{
                                fontSize: "clamp(1.05rem, 2vw, 1.35rem)",
                                lineHeight: 1.6,
                                marginBottom: "26px",
                                color: "#e9edf7",
                            }}
                        >
                            Erfahrenes medizinische Fachkräfte aus Tunesien für deutsche Krankenhäuser
                        </p>
                        <a
                            href="/Dienstleistung"
                            style={{
                                display: "inline-block",
                                padding: "12px 28px",
                                borderRadius: "999px",
                                border: "1.5px solid #ffffff",
                                color: "#ffffff",
                                textDecoration: "none",
                                fontWeight: 600,
                                fontSize: "1rem",
                                background: "rgba(255,255,255,0.12)",
                            }}
                        >
                            Mehr zu unseren Leistungen
                        </a>
                    </div>
                </div>
            </div>



            {/* Leistungen section */}
            <div style={{ backgroundColor: "#ffffff", padding: "21px 0" }}>
                <div
                    className="medway-section home-leistungen"
                >
                    <div style={{ textAlign: "center" }}>
                        {/* Bild */}
                    </div>
                    <div style={{ color: "#1f1f1f", textAlign: "left" }}>
                        <div style={{ color: "#111D4B", letterSpacing: "3px", fontWeight: 700, fontSize: "0.85rem" }}>
                            UNSERE LEISTUNGEN
                        </div>
                        <h2 style={{ color: "#8c1030", fontSize: "2.2rem", margin: "12px 0 18px" }}>
                            Sind Sie auf der Suche nach engagiertem Personal?
                        </h2>
                        <p style={{ fontSize: "1rem", lineHeight: 1.7, color: "#4a4a4a", marginBottom: "16px" }}>
                            Bei Medway verstehen wir die Herausforderungen, denen Krankenhaeuser, Kliniken und
                            Pflegeeinrichtungen heute gegenueberstehen. Der Mangel an <strong>qualifiziertem Personal</strong> erschwert
                            nicht nur den reibungslosen Ablauf medizinischer Einrichtungen, sondern beeintraechtigt auch
                            die <strong>Qualitaet der Patientenversorgung</strong>.
                        </p>
                        <p style={{ fontSize: "1rem", lineHeight: 1.7, color: "#4a4a4a" }}>
                            Genau hier setzen wir an, indem wir eine <strong>Loesung</strong> bieten, die sowohl effektiv als auch nachhaltig ist.
                        </p>
                        <h3 style={{ color: "#8c1030", marginTop: "26px", marginBottom: "14px", fontSize: "1.3rem" }}>
                            Wir vermitteln:
                        </h3>
                        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "grid", gap: "10px" }}>
                            {[
                                "Gesundheits- und Krankenpfleger/in, Pflegefachfrau/-mann",
                                "Kinderkrankenpfleger/-innen",
                                "Medizinisch-technische Assistenten/-innen (ATA & OTA)",
                                "Medizinisch-technische Laboratoriumsassistent/-innen (MTLA)",
                                "Medizinisch-technische Radiologieassistent/-innen (MTRA)",
                                "Physiotherapeuten, Hebammen",
                                "Pflegehelfer",
                                "Auszubildende",
                            ].map((item) => (
                                <li key={item} style={{ display: "flex", gap: "10px", alignItems: "flex-start", color: "#3f3f3f" }}>
                                    <span style={{ color: "#111D4B", fontWeight: 700, lineHeight: 1 }}>●</span>
                                    <span>{item}</span>
                                </li>
                            ))}
                        </ul>
                        <a
                            href="/Dienstleistung"
                            style={{
                                display: "inline-block",
                                marginTop: "26px",
                                padding: "12px 28px",
                                borderRadius: "999px",
                                background: "#111D4B",
                                color: "#ffffff",
                                textDecoration: "none",
                                fontWeight: 600,
                            }}
                        >
                            Mehr zu unseren Leistungen
                        </a>
                    </div>
                </div>
            </div>

            <ImageCarousel />

        </>
    );
}

export default Home;
